(function($) {
    var pathname = window.location.pathname;
    pathname = pathname.replace(/\/$/, "");

    $('.left-nav--second-level a').each(function(){
        var href= $(this).attr('href');
        if(href == pathname){
            $(this).addClass('selected').parents('.left-nav--second-level').slideDown();
            $(this).parents('.left-nav--top-item').find('.left-nav--top-link').addClass('opened');

        }
    });

    var wW = $(window).width();
    if(wW <= 700){
        setTimeout(function(){
            $('.left-nav--top-item a').removeClass('opened');
            $('.left-nav--top-item ul').css('display', 'none');
        },510);
    }
    $('.left-nav--top-item a').click(function(){
        $(this).toggleClass('opened');
        $(this).parent().siblings().find('.left-nav--top-link').removeClass('opened');
        $(this).siblings().slideToggle();
        $(this).parent().siblings().find('.left-nav--second-level').slideUp();

    });

    $(window).resize(function(){
        var wW = $(window).width();
        if(wW <= 0){
            $('.left-nav--top-item a').removeClass('opened');
            $('.left-nav--top-item ul').css('display', 'none');
        }
    });
    /*
    Archives accordion for news pages
     */
    $('.archives--toggle').on('click', function(e){
        e.preventDefault();
       $(this).toggleClass('open');
    });

})(jQuery);
